<script setup>
import appStores from '@/config/app-stores';

const props = defineProps({
  size: {
    type: String,
    default: 'lg',
    validator: (size) => ['md-alt', 'md', 'lg'].includes(size),
  },

  withMobileDeviceDetection: {
    type: Boolean,
    default: false,
  },
  mobileTextKeyFormat: {
    type: String,
    default: 'full',
    validator: (value) => ['full', 'short'].includes(value),
  },
});

const { t } = useI18n();

// breakpoint
const breakpoint = useCustomBreakpoints();
const breakpointDownSm = breakpoint.smaller('sm');

// device
const { isApple, isAndroid } = useDevice();
const isUnknownDevice = computed(() => !isApple && !isAndroid);

function getStoreText(store) {
  if (props.mobileTextKeyFormat === 'full') return t(store.textKey);
  else if (store.shortTextKey) return t(store.shortTextKey);
}
</script>

<template>
  <div
    class="bundles-app-buttons"
    :class="`bundles-app-buttons--size--${size}`"
  >
    <template v-for="(store, index) in Object.values(appStores)" :key="index">
      <UiButton
        v-if="
          (withMobileDeviceDetection &&
            ((isApple && store.isApple) || (isAndroid && !store.isApple))) ||
          isUnknownDevice ||
          !breakpointDownSm ||
          !withMobileDeviceDetection
        "
        class="bundles-app-buttons__button"
        :class="{
          [`bundles-app-buttons__button--${store.modifier}`]: store.modifier,
        }"
        :theme="store.withBackground ? 'black' : 'transparent'"
        :href="store.url"
        target="_blank"
        rel="nofollow"
      >
        <template #icon-left>
          <CImage
            class="bundles-app-buttons__icon"
            :class="{
              [`bundles-app-buttons__icon--${store.modifier}`]: store.modifier,
            }"
            :src="store.icon"
            :alt="store.alt"
            loading="lazy"
          />
        </template>

        <template v-if="store.textKey || store.shortTextKey" #default>
          <span class="bundles-app-buttons__font hidden-desktop">
            {{ getStoreText(store) }}
          </span>
        </template>
      </UiButton>
    </template>
  </div>
</template>
